import { api } from 'agent';
import { InspectedObjectDetailsDTO } from './dto/InspectedObjectDetailsDTO';

export default function getInspectedObjectDetailsById(
  id: number
): Promise<InspectedObjectDetailsDTO> {
  return api
    .get(`object/${id}`)
    .then((response: { data: InspectedObjectDetailsDTO }) => response.data);
}
